import { BaseModel } from "./base.model";
import { IBaseModel } from "./abstract/ibaseModel.interface";

export class RolePage implements IBaseModel {
    id: number;
    roleId: number;
    pageId: number;
    isAccess: boolean;
    isAdd: boolean;
    isEdit: boolean;
    isDelete: boolean;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/rolePage.model.ts